export default __webpack_public_path__ + "static/GlitchPepe-5f6e2e5e6f2a6a69de7e62a0ea46004e.gif";